/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'wine_bottle': {
    width: 60,
    height: 60,
    viewBox: '0 0 60 60',
    data: '<path pid="0" d="M40.722 6.5V20C42.807 22.333 46 24.047 46 27.446V55.5c0 1.657-1.418 3-3.167 3H30.167c-1.75 0-3.167-1.343-3.167-3V27.447c0-2.954 3.381-5.323 5.278-7.447V6.5M40.722 6h-8.444V4c0-1.105-.111-2 1.055-2h6.334c1.166 0 1.055.895 1.055 2v2zM27 31h19M46 49H33.333M31.222 49H27M32 16h5M39 16h2" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/><path pid="1" d="M27.722 6.5V20c.64.717 1.386 1.375 2.111 2.042m0 36.458H17.167c-1.75 0-3.167-1.343-3.167-3V27.447c0-2.954 3.381-5.323 5.278-7.447V6.5M27.722 6h-8.444V4c0-1.105-.111-2 1.055-2h6.334c1.166 0 1.055.895 1.055 2v2zM24 49H14M24 31h-4M18.222 31H14M28 16h-5M21 16h-2" _stroke="#000230" stroke-width="2" stroke-miterlimit="10"/>'
  }
})
